import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import ScCheckbox from "../../ui-kit/checkbox";

type PermissionItemProps = Readonly<{
  label: string;
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
}>;

const PermissionItem = ({
  label,
  value,
  disabled,
  onChange,
}: PermissionItemProps) => {
  const { t } = useTranslation();
  return (
    <View className="flex-row items-center justify-start gap-2">
      <ScCheckbox value={value} disabled={disabled} onChange={onChange} />
      <Text className={`text-slate text-sm ${disabled ? "opacity-40" : ""}`}>
        {t(label)}
      </Text>
    </View>
  );
};

export default PermissionItem;
